









































































































































































































































































import Vue, { PropType } from 'vue'
import { DashboardConfig } from '@/interfaces/custom-dashboard'

import VueGridLayout from 'vue-grid-layout'
import CustomTable from './helper-components/dashboard-components/CustomTable.vue'
import CustomTableByValue from './helper-components/dashboard-components/CustomTableByValue.vue'
import CustomCheckbox from './helper-components/dashboard-components/CustomCheckbox.vue'
import CustomInputNumber from './helper-components/dashboard-components/CustomInputNumber.vue'
import CustomMultiSelect from './helper-components/dashboard-components/CustomMultiSelect.vue'

import '@/styles/custom-dashboard.css'

export default Vue.extend({
  components: {
    // @ts-ignore Custom Table components give me overload error.
    CustomTable,
    // @ts-ignore
    CustomTableByValue,
    CustomCheckbox,
    CustomInputNumber,
    CustomMultiSelect,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },

  props: {
    userId: Number,
    dashboard: Object as () => DashboardConfig,
    dashboardOwners: {
      type: String,
      default: ''
    },
    dateOptions: {
      type: Object as PropType<{ disabledDate?: (date: string) => boolean }>,
      default: () => {}
    }
  },

  mounted () {
    // TODO: find way to fix typescript configuration for vue components. Currently cannot reference
    // props in components without getting type errors. Potential solutions are using Vue Class-Styled
    // components or Vue property decorators.
    // @ts-ignore
    this.$store.commit('customDashboard/setCurrentDashboard', this.dashboard)
  },

  methods: {
    handleSelectionChange (index: number, value: string) {
      this.$emit('handleSelectionChange', index, value)
    },

    applyFilters (index: number) {
      this.$emit('applyFilters', index)
    }
  }
})
